<template>
  <v-dialog
    :model-value="modelValue"
    max-width="480"
    persistent
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card rounded="xl" class="user-dialog-card kb-delete-dialog">
      <div class="dialog-header d-flex align-center justify-space-between">
        <div class="d-flex align-center ga-3">
          <div class="dialog-header__icon dialog-header__icon--danger">
            <v-icon color="error" size="22">mdi-delete-outline</v-icon>
          </div>
          <span class="dialog-header__title">Delete knowledge file</span>
        </div>
        <v-btn
          icon
          variant="text"
          size="small"
          class="dialog-close-btn"
          :disabled="deleting"
          rounded="lg"
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="dialog-body">
        <p class="kb-delete-dialog__text mb-0">
          Delete
          <strong>{{ fileLabel || 'this file' }}</strong>
          from your knowledge library? This cannot be undone.
        </p>
      </v-card-text>

      <v-card-actions class="dialog-footer">
        <v-spacer />
        <v-btn
          variant="tonal"
          color="secondary"
          :disabled="deleting"
          rounded="lg"
          class="text-none"
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          variant="flat"
          color="error"
          :loading="deleting"
          rounded="lg"
          class="text-none"
          @click="$emit('confirm')"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteKnowledgeBaseFileDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    fileLabel: { type: String, default: '' },
    deleting: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'confirm'],
  methods: {
    close() {
      if (!this.deleting) {
        this.$emit('update:modelValue', false)
      }
    },
  },
}
</script>

<style scoped>
.kb-delete-dialog__text {
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--y-text-muted, #64748b);
}

.dialog-header__icon--danger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--y-radius-md, 12px);
  background: rgba(var(--v-theme-error), 0.12);
}
</style>
